import { Box, Modal, Typography, useTheme } from '@mui/material'
import React from 'react'
import { CustomeModalButton } from '../../../lib/formik/NewFormInputs'

type Props = {
    open: boolean
    setClose: React.Dispatch<React.SetStateAction<boolean>>
    title: string
    desc: string
    handleConfirm?: () => void
    isLoading?: boolean
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '533px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: '12px',
    p: '24px',
    ':focus': {
        outline: 'none'
    }
}

function ConfirmRecomment(props: Props) {
    const { open, setClose, title, desc, handleConfirm, isLoading } = props
    const { palette } = useTheme()

    const handleClose = () => {
        setClose(false)
    }

    return (
        <Modal
            open={open}
            // onClose={handleClose}
            aria-labelledby={title}
            aria-describedby={'form-modal'}
        >
            <Box
                sx={style}>
                <Typography variant='h2' color={palette.text.primary}>{title}</Typography>
                <Typography mt={'12px'}>{desc}</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: '48px' }}>
                    <CustomeModalButton lookType={'outlined'} btnText={'Cancel'} onClick={handleClose} disabled={isLoading} boxStyle={{ borderRadius: '4px' }} />
                    <CustomeModalButton lookType={'contained'} btnText={'Confirm'} onClick={handleConfirm} isLoading={isLoading} boxStyle={{ borderRadius: '4px' }} />
                </Box>
            </Box>
        </Modal >
    )
}

export default ConfirmRecomment